import { createReducer, on } from '@ngrx/store';
import * as NewsActions from './news.actions';
import { News } from '../news.model';

export interface NewsState {
  list: News[];
  loading: boolean;
  error: string | null;
}

export const newsFeatureKey = 'news';

export const initialState: NewsState = {
  list: [],
  loading: false,
  error: null,
};

export const newsReducer = createReducer(
  initialState,

  on(NewsActions.loadNews, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(NewsActions.loadNewsSuccess, (state, { news }) => ({
    ...state,
    list: news ?? [],
    loading: false,
    error: null,
  })),

  on(NewsActions.loadNewsError, (state, { error }) => ({
    ...state,
    list: [],
    loading: false,
    error,
  })),
);
